import { render, staticRenderFns } from "./other-edit.vue?vue&type=template&id=305c7f25&scoped=true&"
import script from "./other-edit.vue?vue&type=script&lang=js&"
export * from "./other-edit.vue?vue&type=script&lang=js&"
import style0 from "./other-edit.vue?vue&type=style&index=0&id=305c7f25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305c7f25",
  null
  
)

export default component.exports